const formatOrder = ({ value }) => (
    Number.isInteger(value) ? (value + 1) : value
  );

export default formatOrder